// KHIYARSA PATCH: convert a selected text element into a bullet list
// ("تحويل إلى قائمة نقاط"). Deterministic — multi-line text bullets each
// non-empty line; a single paragraph is split on sentence boundaries
// (. ! ? ؟ ؛ ।). One history-recorded, undoable step. NO AI.
import {
  CaptureUpdateAction,
  convertTextToBullets,
  getContainerElement,
  isNonDeletedElement,
  isTextElement,
  newElementWith,
  redrawTextBoundingBox,
  refreshTextDimensions,
  updateBoundElements,
} from "@excalidraw/element";

import { getSelectedElements } from "../scene";

import { bulletListIcon } from "../components/icons";

import { register } from "./register";

export const actionConvertToBulletList = register({
  name: "convertToBulletList",
  label: "labels.convertToBulletList",
  icon: bulletListIcon,
  trackEvent: { category: "element" },
  predicate: (elements, appState) => {
    const selectedElements = getSelectedElements(elements, appState);
    if (
      selectedElements.length !== 1 ||
      !isTextElement(selectedElements[0]) ||
      !selectedElements[0].originalText.trim()
    ) {
      return false;
    }
    // hide a no-op entry (already fully bulleted / nothing to split)
    return (
      convertTextToBullets(selectedElements[0].originalText) !==
      selectedElements[0].originalText
    );
  },
  perform: (elements, appState, _, app) => {
    const selectedElements = getSelectedElements(elements, appState);
    const target = elements.find(
      (element) => element.id === selectedElements[0]?.id,
    );

    if (!target || !isTextElement(target)) {
      return false;
    }

    const nextText = convertTextToBullets(target.originalText);
    if (nextText === target.originalText) {
      return false;
    }

    const elementsMap = app.scene.getNonDeletedElementsMap();
    const container = getContainerElement(target, elementsMap);

    if (container) {
      // container-bound text: mutate + redraw so the container grows with
      // the added markers/lines
      app.scene.mutateElement(target, {
        originalText: nextText,
        text: nextText,
      });
      redrawTextBoundingBox(target, container, app.scene);

      return {
        appState,
        elements: app.scene.getElementsIncludingDeleted(),
        captureUpdate: CaptureUpdateAction.IMMEDIATELY,
      };
    }

    // unbound text (incl. autoResize=false wrapped text — re-wraps at the
    // fixed width)
    const converted = newElementWith(target, {
      originalText: nextText,
      ...refreshTextDimensions(target, null, elementsMap, nextText),
    });

    if (isNonDeletedElement(converted)) {
      updateBoundElements(converted, app.scene, {
        changedElements: new Map([[converted.id, converted]]),
      });
    }

    return {
      appState,
      elements: elements.map((element) =>
        element.id === converted.id ? converted : element,
      ),
      captureUpdate: CaptureUpdateAction.IMMEDIATELY,
    };
  },
});
